// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2faBw","button":"style_button__2opKE"};